import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { externalKeyboardCommands } from '@shared/constants/CommandValues';
import { createUUID } from '@shared/constants/Keys';
import { IControlFieldProps } from '@shared/models/components/IControlFieldProps';
import { useTranslation } from 'react-i18next';

function ExternalKeyControlField({ value, onChange, disabled }: IControlFieldProps) {
    const { t } = useTranslation();
    const fieldId = createUUID();
    return (
        <FormControl fullWidth>
            <InputLabel id={fieldId}>{t('common:keys.label')}</InputLabel>
            <Select
                disabled={disabled}
                labelId={fieldId}
                value={value}
                label={t('common:keys.label')}
                onChange={(e) => onChange(e.target.value)}>
                {externalKeyboardCommands.map((c) => (
                    <MenuItem key={c.value} value={c.value}>
                        {c.translationKey ? t(c.translationKey) : c.title}
                    </MenuItem>
                ))}
            </Select>
        </FormControl>
    );
}

export default ExternalKeyControlField;
